export const getOutletsWithOneAssociatedDagRun = (marketInsightRunsForThisPeriod) => {
    return marketInsightRunsForThisPeriod.map(({outlet, runIdentifiers}) => {
        if(runIdentifiers.length === 1) {
            return {outlet, runIdentifier: runIdentifiers[0]}
        }

        return undefined
    })
        .filter(x => x);
}